/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weakpassworderror2Inputs */

const en_weakpassworderror2 = /** @type {(inputs: Weakpassworderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password is too weak. Please choose a stronger password.`)
};

const de_weakpassworderror2 = /** @type {(inputs: Weakpassworderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Passwort ist zu schwach. Nimm ein stärkeres.`)
};

/**
* | output |
* | --- |
* | "Password is too weak. Please choose a stronger password." |
*
* @param {Weakpassworderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const weakpassworderror2 = /** @type {((inputs?: Weakpassworderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weakpassworderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weakpassworderror2(inputs)
	return de_weakpassworderror2(inputs)
});
export { weakpassworderror2 as "weakPasswordError" }